import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectDocumentStoreActions,
  ProjectDocumentStoreSelectors,
  ProjectDocumentStoreReducer,
} from './index';
import { ProjectDocumentDto } from '@cradua/data';

@Injectable()
export class ProjectDocumentFacade {
  constructor(
    private store: Store<
      ProjectDocumentStoreReducer.ProjectDocumentPartialState
    >
  ) {}

  projectManagementRecord$ = this.store.select(
    ProjectDocumentStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProjectDocumentStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProjectDocumentStoreSelectors.getProjectDocumentError
  );

  getselected() {
    return this.store.select(ProjectDocumentStoreSelectors.getSelected);
  }

  get isLoadingProjectDocument() {
    this.store.dispatch(ProjectDocumentStoreActions.loadProjectDocument());
    return this.store.select(
      ProjectDocumentStoreSelectors.loadingProjectDocument
    );
  }

  get loadProjectDocument() {
    this.store.dispatch(ProjectDocumentStoreActions.loadProjectDocument());
    return this.store.select(
      ProjectDocumentStoreSelectors.getAllProjectDocument
    );
  }

  searchProjectDocumentRecord(query) {
    this.store.dispatch(
      ProjectDocumentStoreActions.searchProjectDocumentRecord({ query })
    );
  }

  addProjectDocument(newProjectDocument: ProjectDocumentDto[]) {
    this.store.dispatch(
      ProjectDocumentStoreActions.addProjectDocument({
        newProjectDocument,
      })
    );
  }

  updateProjectDocument(updateProjectDocument: ProjectDocumentDto[]) {
    this.store.dispatch(
      ProjectDocumentStoreActions.updateProjectDocument({
        updateProjectDocument,
      })
    );
  }

  removeProjectDocument(ids: string[]) {
    this.store.dispatch(
      ProjectDocumentStoreActions.removeProjectDocument({ ids })
    );
  }
}
